import path from 'path';
import globToRegExp from 'glob-to-regexp';

const endsWith = (findStr) => (inStr) => inStr.endsWith(findStr);

const isGlob = endsWith('**');

const normaliseExclude = (inDir, exclude) => {
  let normalised = exclude;
  if (!path.isAbsolute(normalised)) {
    normalised = path.join(inDir, normalised);
  }

  if (!isGlob(normalised)) {
    normalised = path.join(normalised, '**');
  }

  return normalised;
};

const isExcluded = (inDir, exclude, checkFile) => {
  const normalised = normaliseExclude(inDir, exclude);
  const isExcludedRegex = globToRegExp(normalised);
  return isExcludedRegex.test(checkFile);
};

export {
  isExcluded,
  normaliseExclude,
};
